<div class="modal-body">
  <div class="mb-3">
    <span
      [innerHTML]="
        'reports.approve.previewEmail.title'
          | translate
            : { notificationProfileName: notificationProfile()?.name }
      "
    ></span>
  </div>
  <div class="row form-group">
    @if (emailConfig().to.length) {
      <div class="col-12 mb-2">
        <label class="label form-control-label label-primary">{{
          'reports.approve.previewEmail.to' | translate
        }}</label>
        <div>{{ emailConfig().to.join(', ') }}</div>
      </div>
    }

    @if (emailConfig().cc.length) {
      <div class="col-12 mb-2">
        <label class="label form-control-label label-primary">{{
          'reports.approve.previewEmail.cc' | translate
        }}</label>
        <div>{{ emailConfig().cc.join(', ') }}</div>
      </div>
    }

    @if (emailConfig().bcc.length) {
      <div class="col-12 mb-2">
        <label class="label form-control-label label-primary">{{
          'reports.approve.previewEmail.bcc' | translate
        }}</label>
        <div>{{ emailConfig().bcc.join(', ') }}</div>
      </div>
    }

    @if (emailConfig().subject) {
      <div class="col-12 mb-2">
        <label class="label form-control-label label-primary">{{
          'reports.approve.previewEmail.subject' | translate
        }}</label>
        <div>{{ emailConfig().subject }}</div>
      </div>
    }
    @if (emailConfig().body) {
      <div class="col-12 mb-2">
        <label class="label form-control-label label-primary">{{
          'reports.approve.previewEmail.body' | translate
        }}</label>
        <div style="white-space: pre-line">{{ emailConfig().body }}</div>
      </div>
    }
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-clear me-2" (click)="onEditEmail()">
    <span>{{ 'common.buttons.btnEdit' | translate }}</span>
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="
      !notificationProfile ||
      templateType() === TemplateType.NotQualified ||
      templateType() === TemplateType.Canceled
    "
    (click)="onSendEmail()"
  >
    {{ 'reports.approve.buttons.sendEmail' | translate }}
  </button>
</div>
